import './App.css';
import Counseling from './components/Counseling';
import FAQ from './components/FAQ';
import FeaturedResults from './components/FeaturedResults';
import FooterNew from './components/FooterNew';
import Navbar from './components/NavBar';
import StudyMethod from './components/StudyMethod';
import NewStudyMethod from './components/NewStudyMethod';
// import Trailer from './components/Trailer';
import Financing from './components/Financing';
import Header from './components/Header';
import Master from './components/Master';
import Memberships from './components/Memberships';
import FloatingSidebar from './components/FloatingSidebar';
import VideoTrailer from './components/VideoTrailer';
import HeaderForm from './components/HeaderForm';
import Gallery from './components/Gallery';

function App() {
	return (
		<div className='App'>
			<Navbar />
			{/* <FloatingSidebar /> */}
			<Header />
			<HeaderForm />
			{/* <VideoTrailer /> */}
			<Master />
			{/* <Trailer /> */}
			<NewStudyMethod />
			<Gallery />
			<Memberships />
			{/* <Financing /> */}
			<Counseling />
			{/* <FeaturedResults /> */}
			<FAQ />
			<FooterNew />
		</div>
	);
}

export default App;
